import React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { isWeb } from "../../../../../helpers/utils";

export default function InsightsIcon(props) {
  const width = props.width || 26;
  const height = props.height || 26;

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M22.7497 8.66602C21.1788 8.66602 20.3013 10.226 20.6588 11.3852L16.813 15.2418C16.488 15.1443 16.0113 15.1443 15.6863 15.2418L12.9238 12.4793C13.2922 11.3202 12.4147 9.74935 10.833 9.74935C9.26217 9.74935 8.37384 11.3093 8.74217 12.4793L3.80217 17.4085C2.64301 17.051 1.08301 17.9285 1.08301 19.4993C1.08301 20.691 2.05801 21.666 3.24967 21.666C4.82051 21.666 5.69801 20.106 5.34051 18.9468L10.2697 14.0068C10.5947 14.1043 11.0713 14.1043 11.3963 14.0068L14.1588 16.7693C13.7905 17.9285 14.668 19.4993 16.2497 19.4993C17.8205 19.4993 18.7088 17.9393 18.3405 16.7693L22.1972 12.9235C23.3563 13.281 24.9163 12.4035 24.9163 10.8327C24.9163 9.64102 23.9413 8.66602 22.7497 8.66602Z"
        fill="url(#paint0_linear_12555_166528)"
      />
      <Path
        d="M16.25 9.75L17.2683 7.5075L19.5 6.5L17.2683 5.4925L16.25 3.25L15.2533 5.4925L13 6.5L15.2533 7.5075L16.25 9.75Z"
        fill="url(#paint1_linear_12555_166528)"
      />
      <Path
        d="M3.79134 11.9167L4.33301 9.75L6.49967 9.20833L4.33301 8.66667L3.79134 6.5L3.24967 8.66667L1.08301 9.20833L3.24967 9.75L3.79134 11.9167Z"
        fill="url(#paint2_linear_12555_166528)"
      />
      {isWeb ? (
        <Defs>
          <LinearGradient
            id="paint0_linear_12555_166528"
            x1="1.08301"
            y1="11.4853"
            x2="5.0325"
            y2="26.2803"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_12555_166528"
            x1="13"
            y1="4.65964"
            x2="16.1289"
            y2="11.053"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_12555_166528"
            x1="1.08301"
            y1="7.6747"
            x2="3.69045"
            y2="13.0025"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      ) : null}
    </Svg>
  );
}
